// exportMeetD.js

import Papa from 'papaparse';
import {
  formatLastName,
  formatBirthDate,
  getGender,
  formatMeetEntryMark,
  getDefaultTeam,  // <-- Importamos la función
} from '../../../utils/meetUtils';
import { computeAge } from '../../../utils/dateUtils';

/**
 * Exportación en formato Meet Manager (Reporte D).
 * - Sin encabezado.
 * - Delimitador punto y coma (;).
 * - Ahora incluye la Edad (columna 9).
 *
 * Formato típico de D Record (20 columnas):
 *  1.  D
 *  2.  Last Name
 *  3.  First Name
 *  4.  Initial
 *  5.  Gender
 *  6.  BirthDate (MM/DD/YYYY)
 *  7.  TeamCode
 *  8.  TeamName
 *  9.  Age
 * 10.  School Year (opcional)
 * 11.  Event Code
 * 12.  Entry Mark
 * 13.  Event Measure (M para campo, vacío para pista)
 * 14.  Division (catNumber)
 * 15.  Competitor #
 * 16.  Finish Place
 * 17.  Declaration Status
 * 18.  Entry Note
 * 19.  Not in use
 * 20.  Alternate
 *
 * @param {Array} inscripciones - Array de inscripciones
 * @param {string} competitionName - Nombre de la competencia
 * @param {number} [maxEvents] - (Opcional) Máximo de pruebas, si lo necesitas
 */
export function exportMeetD(inscripciones, competitionName, maxEvents) {
  const csvRows = [];

  inscripciones.forEach((insc) => {
    if (!insc.pruebasData || insc.pruebasData.length === 0) return;

    const entryType = 'D';
    const lastName = formatLastName(insc.apellido);
    const firstName = insc.nombre || '';
    const initial = '';
    const gender = getGender(insc.rama);
    const birthDate = formatBirthDate(insc);

    // Usamos getDefaultTeam en lugar de la lógica manual
    const { teamCode, teamName } = getDefaultTeam(insc.equipo);

    // Calculamos la edad (opcional)
    const ageVal = computeAge(insc.anioNacimiento, insc.mesNacimiento, insc.diaNacimiento);
    const age = ageVal ? String(ageVal) : '';

    insc.pruebasData.forEach((event) => {
      const row = [];
      row.push(entryType);               //  1. D
      row.push(lastName);               //  2. Last Name
      row.push(firstName);              //  3. First Name
      row.push(initial);                //  4. Middle Initial
      row.push(gender);                 //  5. Gender
      row.push(birthDate);              //  6. Birth Date
      row.push(teamCode);               //  7. Team Code
      row.push(teamName);               //  8. Team Name
      row.push(age);                    //  9. Age
      row.push('');                     // 10. School Year
      row.push(event.eventCode || '');  // 11. Event Code
      row.push(formatMeetEntryMark(event)); // 12. Entry Mark
      // 13. Event Measure (campo => 'M', si no => '')
      const measure = (event.tipoMarca || '').toLowerCase() === 'campo' ? 'M' : '';
      row.push(measure);
      // 14. Division (catNumber)
      row.push(insc.catNumber ? String(insc.catNumber) : '');
      // 15. Competitor #
      row.push('');
      // 16. Finish Place
      row.push('');
      // 17. Declaration Status
      row.push('');
      // 18. Entry Note
      row.push('');
      // 19. Not in use
      row.push('');
      // 20. Alternate
      row.push('');

      csvRows.push(row);
    });
  });

  // Convertimos a CSV (delimitador ";", sin encabezado)
  let csv = Papa.unparse(csvRows, {
    quotes: false,
    header: false,
    delimiter: ';',
  });
  // Quitar comillas
  csv = csv.replace(/"/g, '');

  // Descargar
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.setAttribute('download', `${competitionName}_inscritos_MeetManagerD.csv`);
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  URL.revokeObjectURL(url);
}
